/* radiobuttons */
$(document).on('change', '.__radiobuttons input', function() {
    if ($(this).is(':checked')) {
        $(this)
            .closest('.__radiobuttons')
            .find('.input_wrap > label')
            .removeClass('__checked');
        $(this)
            .parent()
            .addClass('__checked');
    }
});
$('.__radiobuttons input:checked')
    .parent()
    .addClass('__checked');

/* checkboxes */
$(document).on('change', '.__checkboxes input', function() {
    if ($(this).is(':checked')) {
        $(this)
            .parent()
            .addClass('__checked');
    } else {
        $(this)
            .parent()
            .removeClass('__checked');
    }
});
$('.__checkboxes input:checked')
    .parent()
    .addClass('__checked');


$('.__select2').each(function() {
    // var selectId = $(this).attr('id').parent;
    // console.log(selectId)
    $(this).select2({
        containerCssClass: 'select2-css',
        // dropdownParent: selectId
    })
});

$('.__select.__nosearch select').each(function() {
    var selectId = $(this).attr('id').parent;
    $(this).select2({
        containerCssClass: 'select2-css',
        minimumResultsForSearch: Infinity,
        dropdownParent: selectId
    })
});

flatpickr(".DatePicker");
flatpickr(".TimePicker",{
    enableTime: true,
    noCalendar: true,
    dateFormat: "H:i",
    time_24hr: true
});
